export const USER_SET_GOAL_DETAILS = 'USER_SET_GOAL_DETAILS';
export const USER_GOAL_ACHIVED = 'USER_GOAL_ACHIVED';
export const USER_CME_POINTS_ACHIVED = 'USER_CME_POINTS_ACHIVED';
export const USER_ACTIVITY_LIST = 'USER_ACTIVITY_LIST'; 
